import React from 'react';
import './testimonial.css';
import testimonials from '../data/SAP/testimonial.json';
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { atci_lkm_sap_mail, saraswathi_mail } from '../utils/mailIds';

const Testimonial = () => {
  const [total_tsmn_cards, set_total_tsmn_cards] = useState(9);
  const [show, setShow] = useState(false);
  const [showTestimonialModal, setShowTestimonialModal] = useState(false);
  const [testimonialModalContent, setTestimonialModalContent] = useState({});
  const designationOrder = [
  "Accenture Leadership",
  "Associate Director",
  "Technology Principal",
  "Senior Manager",
  "Manager",
  "Assoc Manager",
  "Application Development Assoc Manager",
  "Team Lead",
  "Application Development Team Lead",
  "Senior Analyst",
  "Analyst",
  "Application Development Analyst",
  "Associate",
  "Application Development Associate"
];
  //let testimonial_with_paging_arr = testimonials.slice(0, total_tsmn_cards);
  const sortedTestimonials = [...testimonials].sort((a, b) => {
  const indexA = designationOrder.indexOf(a.designation);
  const indexB = designationOrder.indexOf(b.designation);
  // If designation not found, push it to the end
  return (indexA === -1 ? Infinity : indexA) - 
         (indexB === -1 ? Infinity : indexB);
});
let testimonial_with_paging_arr = sortedTestimonials.slice(0, total_tsmn_cards);

  let total_testimonials = testimonials.length;

  const load_more = () => {
    set_total_tsmn_cards(total_tsmn_cards + 3);    
  };

  const handleTestmonialModal = (tsmn_idx) => {
    setShowTestimonialModal(true);    
    const tsmn_obj = testimonial_with_paging_arr.filter((obj,index) => {      
      return tsmn_idx === index;
    });    
    setTestimonialModalContent(tsmn_obj[0]);
  }

  const botClickFun = () => {
    document.getElementById('cai-webclient-builtin-button').click();
  };
  const handleOpenModal = () => {
    setShow(true);
  };
  const handleCloseModal = () => {
    setShow(false);
  };
  return (
    <div className="testimonial">
      <div className="testimonial_banner1">
        <img
          src={process.env.PUBLIC_URL + '/images/SAP/sap_testimonials.png'}
          alt="Sap-Banner"
          className="img-responsive testimonial-img1"
        />
        <div>
          {/* <h1>Testimonials</h1>
              <span>Hear from our Stakeholders...</span> */}
          {/* <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Odit fuga doloribus vitae commodi quibusdam quas 
                magni quasi dolores neque laudantium.</p> */}
        </div>
      </div>
      <div className="testimonial_video">
        {/* <div className="tm_video"> */}
          {/* <img className="tm_video_play_icon" src="images/SAP/testimonial/video-play-icon.png" alt="video-play-icon" /> */}
          {/* <video width="420" height="200" controls>
            <source src={process.env.PUBLIC_URL + "/images/SAP/testimonial/video.mp4"} type="video/mp4" />
          </video> */}
        {/* </div> */}
        <div className="tm_video">
          {/* <img className="tm_video_play_icon" src="images/SAP/testimonial/video-play-icon.png" alt="video-play-icon" /> */}
          <video height="220" controls>
            <source src={process.env.PUBLIC_URL + "/images/SAP/testimonial/video.mp4"} type="video/mp4" />
          </video>
        </div>
        {/* <div className="tm_text">
       
          <div>
            <h2>Lorem Epsum</h2>
            <h4>Lorem Ipsum is a dummy text.</h4>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio reprehenderit corporis itaque debitis
              pariatur voluptatum consequuntur neque a animi vero similique aut ducimus molestias molestiae quae
              laboriosam, alias provident iure. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nam quidem
              nobis possimus ullam expedita. Inventore ratione ullam reiciendis labore laborum asperiores cupiditate.
            </p>
          </div>
        </div> */}
      </div>
      <div className="tm_feedback">
        <div className="testimonial_body">
          {testimonial_with_paging_arr.map((tsmn_obj, index) => {
            return (
              <div className="tsmn_cards" key={index}>
                <div className='testi-Header'>
                  <img src={process.env.PUBLIC_URL + '/images/SAP/testimonial/avatar.png'} alt="" className='profile' />
                  <div className='tsm-textWrapp'>
                    <h4>{tsmn_obj.name}</h4>
                    <h5 className="tsmn_designation">{tsmn_obj.designation}</h5>
                    </div>
                </div>
                <img className="clip" src={process.env.PUBLIC_URL + '/images/SAP/testimonial/clip.png'} alt="" />
                {tsmn_obj.content.length > 149 ? 
                  <><p style={{whiteSpace: "pre-wrap"}}>{tsmn_obj.content.slice(0,149)} . . .</p><button onClick={()=>handleTestmonialModal(index)} style={{float: 'right', padding: '5px 12px 5px 12px', cursor: 'pointer',margin: '0px 17px 10px 0px',backgroundColor: '#720e9e',color: 'white',fontWeight:'bold',borderRadius: '5px',border: 'none'}}>View more</button></> :
                  <p style={{whiteSpace: "pre-wrap"}}>{tsmn_obj.content}</p>}                
              </div>
            );
          })}
        </div>
        {total_testimonials !== testimonial_with_paging_arr.length && (
          <div className="testimonial_see_more">
            <span onClick={load_more}>See More...</span>
          </div>
        )}
      </div>
            
      <Modal
        open={showTestimonialModal}        
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      > 
        <div>
          <div style={{textAlign: 'center',marginTop: '20px'}}>            
            <AiOutlineCloseCircle onClick={()=>setShowTestimonialModal(false)} style={{color: 'white',fontSize: '30px',cursor: 'pointer'}} />
          </div>          
          <div className="tsmn_cards tsmn-modal-card">            
            <div className='testi-Header'>
              <img src={process.env.PUBLIC_URL + '/images/SAP/testimonial/avatar.png'} alt="" className='profile' />
              <div className='tsm-textWrapp'>
                <h4>{testimonialModalContent.name}</h4>
                <h5 className="tsmn_designation">{testimonialModalContent.designation}</h5>
              </div>
            </div>
            <img className="clip" src={process.env.PUBLIC_URL + '/images/SAP/testimonial/clip.png'} alt="" />
            <p style={{whiteSpace: "pre-wrap"}}>{testimonialModalContent.content}</p>
          </div>
        </div>
      </Modal>
      

      <div className="socialMediaWrap">
        <button className="iconBtn icon6">
          <a href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/sap_calendar.png'} alt="oracle-icon" />
            <span>SAP Calendar</span>
          </a>
        </button>
        <button className="iconBtn icon5">
          <a href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/catalogue_icon.png'} alt="ecatalogs-icon" />
            <span>SAP eCatalog</span>
          </a>
        </button>
        <button className="iconBtn icon4" onClick={botClickFun}>
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/noun-chatbot-4562760.svg'} alt="oracle-icon" />
          <span>SAP Bot</span>
        </button>
        <button onClick={handleOpenModal} className="iconBtn icon1">
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="oracle-icon" />
          <span>Request for Training</span>
        </button>
        <Modal
          open={show}
          onClose={handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className="model-container">
            <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
              X
            </span>
            <h4>Request For Training</h4>
            <div className="model_heading_reqtraining">
              <p className="model_name_reqtraining">
                <a
                  href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                  target="_blank"
                  rel="noreferrer"
                >
                  Link to raise training request
                </a>
              </p>
              <div className="modal_content_reqtraining">
                For further queries please get in touch with <br />
              </div>
              <p className="model_contact_reqtraining">
                <a href={`mailto:${saraswathi_mail}`} target="_blank" rel="noreferrer">
                  Swaminathan, Saraswathi.
                </a>
              </p>
            </div>
          </div>
        </Modal>
        <button className="iconBtn icon2">
          <a
            href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="oracle-icon" />
            <span>Connect with Community</span>
          </a>
        </button>
        <button className="iconBtn icon3">
          <a href={`mailto:${atci_lkm_sap_mail}`} target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="oracle-icon" />
            <span>Contact Us</span>
          </a>
        </button>
      </div>
    </div>
  );
};

export default Testimonial;
